import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { NavHashLink } from 'react-router-hash-link';

const Header = () => {
    const [scroll, setScroll] = useState("");
    const [button, setButton] = useState(false);

    function getScrollPosition() {
        return {
            x: window.scrollX || document.documentElement.scrollLeft,
            y: window.scrollY || document.documentElement.scrollTop
        };
    }

    const closeNavbar = () => {
        const closeButton = document.querySelector(".btn-close");
        if (closeButton) closeButton.click();
    }

    window.addEventListener("scroll", () => {
        const scrollPos = getScrollPosition();

        if (scrollPos.y >= 15) {
            setScroll("header-scroll");
            setButton(true);
        } else {
            setScroll("");
            setButton(false);
        }
    });

    return(
        <header className={`header ${scroll}`}>
            <div className="header-wrapper d-flex justify-content-center">
                <div className="header-container d-flex align-items-center">
                    <NavLink to={`${process.env.PUBLIC_URL}/`}>
                        <img 
                            className="header-logo"
                            src={`${process.env.PUBLIC_URL}/logo/logo-mek-white.png`} 
                            alt="Logo Mustafa Ekiz"
                            loading="lazy" />
                    </NavLink>
                    <div className="header-menus d-none d-xl-flex">
                        <NavHashLink smooth to={`${process.env.PUBLIC_URL}/#about`}>À propos</NavHashLink>
                        <NavHashLink smooth to={`${process.env.PUBLIC_URL}/#timeline`}>Parcours</NavHashLink>
                        <div className="header-sub-list">
                            <NavHashLink smooth className="header-link header-sub-link-ref d-flex align-items-center" to={`${process.env.PUBLIC_URL}/#realisations`}>Réalisations</NavHashLink>
                            <ul className="header-sub-menu">
                                <li className="header-sub-link">
                                    <NavLink to="/etudiant">Etudiant</NavLink>
                                </li>
                                <li className="header-sub-link">
                                    <NavLink to="/pro">Professionnel</NavLink>
                                </li>
                            
                            </ul>
                        </div>
                        <NavHashLink smooth to={`${process.env.PUBLIC_URL}/#contact`}>Contactez-moi</NavHashLink>
                       <NavLink to="https://www.linkedin.com/in/mustafa-e-8937a4205/" className="d-flex align-items-center" target="_blank" rel="noopener noreferrer">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                <path d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zM8.951 9.404H6.165V17.5H8.95V9.404zm6.841-.192c-1.324 0-1.993.629-2.385 1.156l-.127.181V9.403h-2.786l.01.484c.006.636.007 1.748.005 2.93l-.015 4.683h2.786v-4.522c0-.242.018-.484.092-.657.202-.483.66-.984 1.43-.984.955 0 1.367.666 1.408 1.662l.003.168V17.5H19v-4.643c0-2.487-1.375-3.645-3.208-3.645zM7.576 5.5C6.623 5.5 6 6.105 6 6.899c0 .73.536 1.325 1.378 1.392l.18.006c.971 0 1.577-.621 1.577-1.398C9.116 6.105 8.53 5.5 7.576 5.5z"/>
                            </svg>
                        </NavLink>
                    </div>
                    <div className="header-mobile-contain d-xl-none">
                        <div className="header-iconburger">
                            <button 
                                type="button" 
                                className="navbar-toggler"
                                data-bs-toggle="offcanvas" 
                                data-bs-target="#offcanvas" 
                                aria-controls="offcanvas"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="3" y1="12" x2="21" y2="12"></line>
                                    <line x1="3" y1="6" x2="21" y2="6"></line>
                                    <line x1="3" y1="18" x2="21" y2="18"></line>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {button && (
                <div className="to-top">
                    <NavHashLink smooth to="#app">
                    <svg width="26" height="25" viewBox="0 0 26 25" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.500002 12L11.5 1L25 14.5L25 23.5L11.5 10L6 15.5L0.5 21" />
                    </svg>
                    </NavHashLink>
                </div>
            )}

            <div className="games-button">
                <NavLink to="/games">
                    <svg width="30" viewBox="0 0 47 34" xmlns="http://www.w3.org/2000/svg" fill="transparent" stroke="#FFFFFF">
                        <path d="M36.3463 27.24C36.3866 27.2975 36.4293 27.3578 36.4742 27.4206M43.242 15.1397C43.3055 15.2521 43.368 15.3727 43.4295 15.5009M43.4295 15.5009C44.6261 17.9961 45.428 23.3503 45.6883 25.828C45.7408 30.2675 42.4812 32.1326 40.8449 32.5103V32.0177C39.5503 31.427 37.471 28.8147 36.4742 27.4206M43.4295 15.5009C42.4695 12.5183 40.3819 6.37236 39.712 5.64996L39.0225 4.74695C38.6722 3.3897 36.6352 0.744172 31.2894 1.02V1.43046C30.9775 1.64937 30.173 2.07077 29.4506 2.0051C28.7282 1.93943 20.6668 1.97773 16.7264 2.0051C16.5185 2.05435 15.9613 1.92629 15.3965 1.02C13.2457 0.926962 8.73071 1.5421 7.87696 4.74695C7.66352 4.7962 7.08232 5.21651 6.46499 6.50371C5.69333 8.1127 1.60518 18.9323 1.5395 21.3951C1.47383 23.8578 -0.627709 28.4878 3.93657 31.5908C4.53858 32.0396 5.95603 32.5858 6.80978 31.1804C7.23118 30.9451 8.45489 29.9392 9.97851 27.7982C11.883 25.122 13.2786 23.0041 17.4324 23.3653C19.8514 23.3653 26.0093 23.3653 31.2894 23.3653C32.1322 23.3926 34.2677 24.1501 36.0672 26.9609L36.4742 27.4206" />
                        <circle cx="26.5282" cy="9.45897" r="0.5"  stroke-width="0.773175"/>
                        <circle cx="31.8148" cy="9.68883" r="0.911973" />
                        <circle cx="37.8895" cy="9.68883" r="0.911973" />
                        <circle cx="34.8685" cy="6.60216" r="0.911973" />
                        <circle cx="34.8685" cy="12.5128" r="0.911973" />
                        <circle cx="29.3519" cy="16.3875" r="1.96274" />
                        <circle cx="12.0143" cy="9.45896" r="1.96274" />
                        <circle cx="29.3522" cy="16.3876" r="1.17467" />
                        <circle cx="12.0143" cy="9.45897" r="1.17467" />
                        <circle cx="20.0594" cy="9.45897" r="0.5"  stroke-width="0.773175"/>
                        <circle cx="23.3103" cy="4.96043" r="1.14183" />
                        <path d="M16.6936 13.9248V19.5563H18.4668V13.9248H16.6936ZM14.7234 15.8129H20.4205V17.6846H14.7234V15.8129Z" />
                        <path d="M23.9505 12.7755C25.0669 12.2107 24.4157 11.5551 23.9505 11.2979H22.6863C21.5698 11.797 22.2211 12.5894 22.6863 12.9233H23.9505" />
                    </svg>
                </NavLink>
            </div>

            <div className="offcanvas offcanvas-start" tabindex="-1" id="offcanvas" aria-labelledby="offcanvasLabel">
                <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close">
                    <svg width="33" height="30" viewBox="0 0 33 30" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 6.23077L10.3939 15.4615L1 24.6923L7.26263 29L16.0303 20.3846L24.798 29L32 24.6923L22.6061 15.4615L32 6.23077L24.798 1L16.0303 9.92308L7.26263 1" />
                    </svg>
                </button>

                <NavHashLink smooth to={`${process.env.PUBLIC_URL}/#about`} onClick={closeNavbar}>À propos</NavHashLink>
                <NavHashLink smooth to={`${process.env.PUBLIC_URL}/#timeline`} onClick={closeNavbar}>Parcours</NavHashLink>
                <div className="header-sub-list">
                    <NavHashLink 
                     smooth 
                     to={`${process.env.PUBLIC_URL}/#realisations`}
                     data-bs-toggle="collapse" data-bs-target="#sousMenu1" aria-expanded="false" aria-controls="sousMenu1"
                     >Réalisations +</NavHashLink>

                    <ul class="collapse list-unstyled ps-3" id="sousMenu1">
                        <li><NavLink onClick={closeNavbar} to="/etudiant">Etudiant</NavLink></li>
                        <li><NavLink onClick={closeNavbar} to="/pro">Professionnel</NavLink></li>
                    </ul>
                </div>
                <NavHashLink smooth onClick={closeNavbar} to={`${process.env.PUBLIC_URL}/#contact`}>Contactez-moi</NavHashLink>
                <NavLink onClick={closeNavbar} to="https://www.linkedin.com/in/mustafa-e-8937a4205/" className="d-flex align-items-center" target="_blank" rel="noopener noreferrer">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zM8.951 9.404H6.165V17.5H8.95V9.404zm6.841-.192c-1.324 0-1.993.629-2.385 1.156l-.127.181V9.403h-2.786l.01.484c.006.636.007 1.748.005 2.93l-.015 4.683h2.786v-4.522c0-.242.018-.484.092-.657.202-.483.66-.984 1.43-.984.955 0 1.367.666 1.408 1.662l.003.168V17.5H19v-4.643c0-2.487-1.375-3.645-3.208-3.645zM7.576 5.5C6.623 5.5 6 6.105 6 6.899c0 .73.536 1.325 1.378 1.392l.18.006c.971 0 1.577-.621 1.577-1.398C9.116 6.105 8.53 5.5 7.576 5.5z"/>
                    </svg>
                </NavLink>
            </div>
            
        </header>
    )
};

export default Header;